import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_2 = {
  class: "body--body-01 tw-text-core-neutral-cold-10",
  "data-test": "alert-message"
}

import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import { AlertStatus, AlertType, AlertTypeInfo } from 'frontcore/presentation/alert/domain/types'
import { computed } from 'vue'
import { useAlertQueueStore } from 'frontcore/presentation/alert/domain/useAlertQueueStore'

export interface Props {
  alertId?: string,
  status: AlertStatus
  type?: AlertType
  message: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CoreAlert',
  props: {
    alertId: { default: '' },
    status: {},
    type: { default: AlertType.INLINE },
    message: {}
  },
  setup(__props: any) {

const { clearMessage } = useAlertQueueStore()

const props = __props

const alertClassMap = (status: AlertStatus) => {
  const borderClass = ' tw-border-solid tw-border'
  switch (status) {
  case AlertStatus.INFO: 
    return props.type === AlertType.TOAST ? 'tw-bg-auxiliary-info-95 tw-border-auxiliary-info-60' + borderClass : 'tw-bg-auxiliary-info-95'
  case AlertStatus.ERROR:
    return props.type === AlertType.TOAST ? 'tw-bg-auxiliary-error-95 tw-border-auxiliary-error-60' + borderClass : 'tw-bg-auxiliary-error-95'
  case AlertStatus.WARNING:
    return props.type === AlertType.TOAST ? 'tw-bg-auxiliary-warning-95 tw-border-auxiliary-warning-60' + borderClass : 'tw-bg-auxiliary-warning-95'
  case AlertStatus.SUCCESS:
    return props.type === AlertType.TOAST ? 'tw-bg-auxiliary-success-95 border-auxiliary-success-60' + borderClass : 'tw-bg-auxiliary-success-95'
  }
}

const iconNameMap = (status: AlertStatus) => {
  switch (status) {
  case AlertStatus.INFO: 
    return 'Info'
  case AlertStatus.ERROR:
    return 'CancelFill'
  case AlertStatus.WARNING:
    return 'Warning'
  case AlertStatus.SUCCESS:
    return 'CheckCircle'
  }
}

const iconClassMap = (type: AlertStatus) => {
  switch (type) {
  case AlertStatus.INFO: 
    return 'tw-fill-auxiliary-info-60' 
  case AlertStatus.ERROR:
    return 'tw-fill-auxiliary-error-60'
  case AlertStatus.WARNING:
    return 'tw-fill-auxiliary-warning-60'
  case AlertStatus.SUCCESS:
    return 'tw-fill-auxiliary-success-60'
  }
}

const combinedProps = computed<AlertTypeInfo>(() => {
  
  return {
    alertClass: alertClassMap(props.status),
    icon: iconNameMap(props.status),
    iconColorClass: iconClassMap(props.status),
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'tw-flex tw-justify-between tw-items-center tw-gap-2',
      'tw-rounded',
      _ctx.type === _unref(AlertType).TOAST ? 'tw-w-80 tw-min-h-14 tw-px-4 tw-py-3' : 'tw-px-3 tw-py-2',
      combinedProps.value.alertClass,
    ]),
    "data-test": "alert-content"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (combinedProps.value.icon)
        ? (_openBlock(), _createBlock(SVGIcon, {
            key: 0,
            colorClass: combinedProps.value.iconColorClass,
            iconName: combinedProps.value.icon,
            "data-test": "alert-icon"
          }, null, 8, ["colorClass", "iconName"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "message", {}, () => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.message), 1)
      ])
    ]),
    (_ctx.type === _unref(AlertType).TOAST)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          "data-test": "alert-close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(clearMessage)(_ctx.alertId)))
        }, [
          _createVNode(SVGIcon, {
            iconName: "Close",
            colorClass: "tw-fill-core-neutral-cold-40",
            remSize: 1.25
          })
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "actions")
  ], 2))
}
}

})